import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import copy from 'clipboard-copy';
import { onWallShared } from 'arts/config/analytics';
import * as classes from './classes.module.scss';

const CopyText = ({ text, numItemsWall }) => {
  const ref = useRef(null);
  const copyLink = () => {
    onWallShared(numItemsWall);
    copy(text);
  };
  return (
    <>
      <input disabled value={ text } ref={ ref } className={ classes.copyInput } />
      <button onClick={ copyLink } type="button" className={ classes.copyLink }>
        Copy Link
      </button>
    </>
  );
};

CopyText.propTypes = {
  text: PropTypes.string.isRequired,
  numItemsWall: PropTypes.number.isRequired
};

export default CopyText;
